module.exports = __webpack_public_path__ + "static/media/Screenshot1.5b4af3c0.png";